import { createTheme } from '@material-ui/core/styles';
import { ThemeMuiTheme } from '@feedback/ui';

export const theme = { ...createTheme(ThemeMuiTheme()) };
